import OpSdk, {MsService} from '@/sdk/OpSdk';
import Ajax from '../../../../bs/src/sdk/ajax/Ajax';

export interface DocBook {
  id: string;
  name: string;
  creator: { id: string, nickname: string };
  seqNo: number;
  createAt: number;
  updateAt: number;
}

function getAjax(): Ajax {
  const sdk = OpSdk.getInstance();
  const ajax = sdk.getAjax(MsService.KK_HELP_DOC);
  return ajax;
}

export function getDocBook(id: string): Promise<DocBook> {
  return getAjax().post('/op/ud/doc/book/get', {id});
}

export function listDocBook(): Promise<DocBook[]> {
  return getAjax().post('/op/ud/doc/book/list');
}
